/**
 * ユーザステータスタイプ.
 */
export const UserStatusType = {
  /** エラー(0). */
  ERROR: 0,
  /** 配車依頼受付中(1). */
  ACCEPTING_DISPATCH_ORDER: 1,
  /** 乗降場所計画指示中(2). */
  BOARDING_LOCATION_PLANNING_ORDER: 2,
  /** 配車計画依頼中(3). */
  DISPATCH_PLANNING_ORDER: 3,
  /** 配車仮予約依頼中(4). */
  DISPATCH_TENTATIVE_RESERVATION_ORDER: 4,
  /** 配車予約確定確認中(5). */
  DISPATCH_RESERVATION_CHECK_CONFIRMATION: 5,
  /** 配車予約確定依頼中(6). */
  DISPATCH_RESERVATION_FIXED_ORDER: 6,
  /** 乗車地誘導中(7). */
  GUIDANCE_RIDE_PLACE: 7,
  /** ユーザ待機中(8). */
  WAITING_USER: 8,
  /** 車両待機中(9). */
  WAITING_VEHICLE: 9,
  /** 認証待機中(10). */
  WAITING_AUTHENTICATION: 10,
  /** ユーザ認証中(11). */
  USER_AUTHENTICATION: 11,
  /** 乗り込み待機中(12). */
  WAITING_RIDE: 12,
  /** 乗り込み中(13). */
  RIDING: 13,
  /** 目的地移動中(14). */
  MOVING_DESTINATION: 14,
  /** 降車地付近接近中(15). */
  ACCESS_IN_DROP_OFF_PLACE_NEAR: 15,
  /** 降車待機中(16). */
  WAITING_DROP_OFF: 16,
  /** 降車中(17). */
  IN_DROP_OFF: 17,
  /** 目的地誘導中(18). */
  GUIDANCE_DESTINATION: 18,
  /** 目的地到着(20). */
  ARRIVED_DESTINATION: 20,
  /** 乗車タイムアウト(19). */
  RIDE_TIMEOUT: 19,
  /** 予約事前通知待機中(21). */
  WAITING_REMIND1: 21,
  /** 予約出発通知待機中(22). */
  WAITING_REMIND2: 22,
  /** 車両アクシデント発生中(99). */
  VEHICLE_ACCIDENT_OCCURRENCE: 99
};

export type UserStatusType = typeof UserStatusType[keyof typeof UserStatusType];



// WEBPACK FOOTER //
// ./src/types/user-status-type.ts